import firebase from 'firebase'
import {firestore, query, collection, where, getAll} from 'firebase/firestore';
import {db, auth} from '../db';
import API_URL from '../api/config.js';

// helper Function
function err(e) {
  return {success: false, error: e};
}

// GameDetail-Testers.vue
/*
  Get all filter field names and values.
  return a promise with an object of testerFields and variantsList
  testerFields is an array of objects related to filter field names and values.
  variantsList is an array of button colors used in the filter.
 */
  async function getFilter() {
    return new Promise(async (resolve, reject) => {
      // get the playTesterFilter document
      db.collection("Constant").doc("playTesterFilter").get()    
      .then(doc => {
        if (!doc.exists) {
          reject({success: false, error: "filter does not exist"})
  
        } else {
          const newFilter = {
            testerFields: doc.data().testerFields,
            variantsList: doc.data().variantsList,
          }
  
          // setting isAdded in each value to false
          newFilter.testerFields.forEach(field => {
            field.fieldValues.forEach(value => {
              value.isAdded = false
            })
          })
  
          resolve({success: true, data: newFilter})
        }
      })
      .catch(e => reject(err(e)))
    }) 
  }

  // GameDetail-Testers.vue
/*
  Get additional Testers that passes the filter and are not in the game yet.
  returns a promise of testerList, totalPage.
  testerList is an array of at most pageSize number of testers that passes the filter and are not in the game yet.
  totalPage is calculated based on the total possible testers.
*/
async function getTester(gameId, pageNum, pageSize, fireStoreFilter) {
    if (!auth.currentUser) {
      throw err("You must be signed in to view testers.")
    }

    const request = async (forceRefresh) => {
      let token
      try {
        token = await auth.currentUser.getIdToken(forceRefresh)
      } catch (e) {
        throw err("Your session has expired. Please sign in again.")
      }

      try {
        return await fetch(`${API_URL}/testers`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            gameId: gameId,
            pageNum: pageNum,
            pageSize: pageSize,
            filter: fireStoreFilter
          })
        })
      } catch (e) {
        throw err("Could not reach the server, so testers could not be loaded.")
      }
    }

    let response = await request(false)
    if (response.status === 401) {
      response = await request(true)
    }

    let data = {}
    try {
      data = await response.json()
    } catch (e) {
      data = {}
    }

    if (!response.ok || !data.success) {
      throw err(data.error || `Server returned ${response.status}`)
    }

    return {success: true, data: data.data}
  }

export default {
    getFilter,
    getTester,
}


// WEBPACK FOOTER //
// ./src/Firestore/FilteringTesters.js